export default {
    bloglist: {
        en: [
            {
                title: 'Best WhatsApp Mod Apps in 2026 - Complete Guide',
                poster: require('@/assets/blog.webp'),
                desc: 'Discover the best WhatsApp mod apps in 2026. Compare GBWhatsApp, FMWhatsApp, YoWhatsApp, and WhatsApp Plus.',
                name: 'en-blog-1',
                url: '/blog/best-whatsapp-mod-apps/',
                date: '2026-03-01',
            },
            {
                title: 'GBWhatsApp Privacy Tips and Tricks',
                poster: require('@/assets/blog.webp'),
                desc: 'Learn how to use GBWhatsApp privacy features to hide online status, blue ticks, and more.',
                name: 'en-blog-2',
                url: '/blog/gbwhatsapp-privacy-tips/',
                date: '2026-03-05',
            },
            {
                title: 'GBWhatsApp vs FMWhatsApp - Complete Comparison',
                poster: require('@/assets/blog.webp'),
                desc: 'Compare GBWhatsApp and FMWhatsApp features, privacy, updates and more.',
                name: 'en-blog-3',
                url: '/blog/gbwhatsapp-vs-fmwhatsapp/',
                date: '2026-03-08',
            },
            {
                title: 'GBWhatsApp vs WhatsApp Official - Complete Comparison 2026',
                poster: require('@/assets/blog.webp'),
                desc: 'Compare GBWhatsApp with WhatsApp Official. Learn the differences in features, privacy, and customization.',
                name: 'en-blog-4',
                url: '/blog/gbwhatsapp-vs-whatsapp-official/',
                date: '2026-03-10',
            },
            {
                title: 'GBWhatsApp vs YoWhatsApp - Complete Comparison',
                poster: require('@/assets/blog.webp'),
                desc: 'Compare GBWhatsApp and YoWhatsApp features, themes, and anti-ban protection.',
                name: 'en-blog-5',
                url: '/blog/gbwhatsapp-vs-yowhatsapp/',
                date: '2026-03-12',
            },
            {
                title: 'How to Backup GBWhatsApp Chat History - Complete Guide',
                poster: require('@/assets/blog.webp'),
                desc: 'Learn how to backup and restore GBWhatsApp chat history using local and Google Drive backup.',
                name: 'en-blog-6',
                url: '/blog/how-to-backup-gbwhatsapp-chat/',
                date: '2026-03-14',
            },
            {
                title: 'How to Fix GBWhatsApp Login Problems',
                poster: require('@/assets/blog.webp'),
                desc: 'Troubleshoot common GBWhatsApp login problems and verification issues.',
                name: 'en-blog-7',
                url: '/blog/how-to-fix-gbwhatsapp-login-problem/',
                date: '2026-03-16',
            },
            {
                title: 'How to Transfer WhatsApp to GBWhatsApp',
                poster: require('@/assets/blog.webp'),
                desc: 'Learn how to transfer your WhatsApp chats to GBWhatsApp safely.',
                name: 'en-blog-8',
                url: '/blog/how-to-transfer-whatsapp-to-gbwhatsapp/',
                date: '2026-03-18',
            },
            {
                title: 'Is GBWhatsApp Legal? Everything You Need to Know',
                poster: require('@/assets/blog.webp'),
                desc: 'Understand the legal status of GBWhatsApp and important considerations before using it.',
                name: 'en-blog-9',
                url: '/blog/is-gbwhatsapp-legal/',
                date: '2026-03-20',
            },
            {
                title: 'Is GB WhatsApp Still Working in 2026?',
                poster: require('@/assets/blog.webp'),
                desc: 'Is GB WhatsApp being banned? Find out whether GB WhatsApp still works in 2026, why users are facing restrictions, and what to do if it stops working.',
                name: 'en-blog-10',
                url: '/blog/is-gb-whatsapp-still-working-2026/',
                date: '2026-08-12',
            },
        ],
    }

}
